import React from 'react';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import { InfoLabel, InfoValue, InfoValueSmall } from './styles';
import Grid from '@mui/material/Grid2';
import { IssuePropTypes } from 'shared/propTypes/issueType';
import { formatDateTimeConversational } from 'utils/dateTime';

import Status from 'views/IssueDetails/components/Status';
import { TextEditedContent } from 'components';
import Box from '@mui/material/Box';

const propTypes = {
  issue: PropTypes.shape(IssuePropTypes).isRequired,
  isClient: PropTypes.bool,
  isTaskManager: PropTypes.bool,
  setConfirmModalInfo: PropTypes.func,
  setConfirmModalUpdateData: PropTypes.func,
  setConfirmModalOpen: PropTypes.func,
};

const KenshinInfo = ({
  issue,
  isClient,
  isTaskManager,
  setConfirmModalInfo,
  setConfirmModalUpdateData,
  setConfirmModalOpen,
}) => {
  // save this for future;
  // const doctorIds = issue.cases.map((item) => item.doctorId).filter(Boolean);
  // const doctorsAssigned = doctors.filter((item) => doctorIds.includes(item.id));
  // const doctorNames = doctorsAssigned.map((doctor) =>
  //   getUserFullName(doctor.firstName, doctor.lastName)
  // );

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Grid container spacing={1}>
          {/* Left Column */}
          <Grid size={6}>
            <Grid container spacing={1}>
              <Grid size={2}>
                <InfoLabel>
                  {intl.get('issue_details_info_label_from')}
                </InfoLabel>
              </Grid>
              <Grid size={10}>
                <InfoValue>{issue.srcOrgName}</InfoValue>
              </Grid>
              <Grid size={2}>
                <InfoLabel>
                  {intl.get('issue_details_info_label_created_time')}
                </InfoLabel>
              </Grid>
              <Grid size={10}>
                <InfoValueSmall>{issue.createdAt}</InfoValueSmall>
                <InfoValueSmall>
                  {formatDateTimeConversational(issue.createdAt)}
                </InfoValueSmall>
              </Grid>
            </Grid>
          </Grid>

          {/* Right Column */}
          <Grid size={6}>
            <Grid container spacing={1}>
              <Grid size={2}>
                <InfoLabel>
                  {intl.get('issue_details_text_description')}
                </InfoLabel>
              </Grid>
              <Grid size={10}>
                <TextEditedContent content={issue.description} />
              </Grid>
              {isTaskManager && (
                <>
                  <Grid size={2}>
                    <InfoLabel>
                      {intl.get('issue_details_text_status')}
                    </InfoLabel>
                  </Grid>
                  <Grid size={10}>
                    <Status
                      isClient={isClient}
                      issue={issue}
                      isDoctor={false}
                      setConfirmModalInfo={setConfirmModalInfo}
                      setConfirmModalUpdateData={setConfirmModalUpdateData}
                      setConfirmModalOpen={setConfirmModalOpen}
                      isKenshin={true}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

KenshinInfo.propTypes = propTypes;

export default KenshinInfo;
